import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { TableButton } from "components/ui";
import FaFileExcelO from "react-icons/lib/fa/file-excel-o";
import { exportIncompleteOrderTracking } from "actions/exports";

const TableControls = ({ query }) => {
  const dispatch = useDispatch();

  const handleExport = () => {
    dispatch(exportIncompleteOrderTracking(query));
  };

  return (
    <div className="query-table-controls">
      <TableButton
        title="Export orders to excel file"
        onClick={handleExport}
      >
        <FaFileExcelO />
      </TableButton>
    </div>
  );
};

export default TableControls;

TableControls.propTypes = {
  query: PropTypes.object.isRequired
};
